import React, { FC, useCallback } from 'react';
import styles from './fileItem.module.scss';
import {TDocumentStatuses, TFile83bData} from "../../../../../@types/global";
import {formatToStandardDateUTC} from "../../../../../helpers/convertDates";
import Activities from "../../../../AdminDashboard/ActivitiesAndDocuments/Activities";
import Documents from "../../../../AdminDashboard/ActivitiesAndDocuments/Documents";
import {useNavigate} from "react-router-dom";
import StatusPill from "../../../../../uiComponents/StatusPill/StatusPill";

interface TFileItemProps {
    data: TFile83bData;
    companyId: number;
    isAdminRole: boolean;
}
const deliveryServices = {
    "USPS":"USPS Tracking Number",
    "FEDEX": "FedEx Tracking Number",
    "NONE" : "Mailed"
}
const FileItem:FC<TFileItemProps> = ({ data, companyId, isAdminRole }) => {

    const {
        activities,
        deadLine,
        grantDate,
        status,
        documents,
        trackingNumber,
        updateDateTime,
        cutOffPast,
        grantId,
        orderNumber,
        physicalCopyStatus,
        deliveryService
    } = data;

    const navigate = useNavigate();

    const onProssedHandler = useCallback(() => {
        if (status === 'PENDING') {
            navigate(`/filing/file-83b?fileId=${data.id}`);
        } else {
            navigate(`/filing/file-83b/continue?fileId=${data.id}`);
        }
    }, [status, data.id, navigate]);    

    return (
        <div className={styles.fileItem}>
            <div className={styles.itemHeader}>
                <div className={styles.itemValue}>
                    <span>Grant Date:</span>
                    <span>{formatToStandardDateUTC(grantDate, ' ')}</span>
                </div>
                <div className={styles.itemValue}>
                    <span>Deadline:</span>
                    <span>{formatToStandardDateUTC(deadLine, ' ')}</span>
                </div>
                <div className={styles.itemValue}>
                    <span>Status:</span>
                    <span>
                        <StatusPill                            
                            status={status as TDocumentStatuses}
                            styleType="secondary"
                        />
                    </span>
                </div>
                <div className={styles.itemValue}>
                    <span>Order Number:</span>
                    <span>{orderNumber || '-'}</span>
                </div>      
                {
                    grantId ? (
                        <div className={styles.itemValue}>
                            <span>Grant ID:</span> 
                            <span>{grantId}</span>
                        </div>
                    ) : null
                }         
                {
                    trackingNumber ? (
                        <div className={styles.itemValue}>
                            <span>{deliveryServices[deliveryService as keyof typeof deliveryServices]}:</span>
                            <span>{trackingNumber}</span>
                        </div>
                    ) : null
                }
                {
                    physicalCopyStatus !== "NONE" ? (
                        <div className={styles.itemValue}>
                            <span>Physical copy status:</span>
                            <span>
                                <StatusPill hideIcon status={physicalCopyStatus} />
                            </span>
                        </div>
                    ) : null
                
                }
            </div>

            <div className={styles.rowDetails}>
                <div className={styles.col}>
                    <Activities data={activities}/>
                </div>
                <div className={styles.col}>
                    <Documents
                        orderNumber={orderNumber}
                        data={documents}
                        companyId={companyId}
                        status={status}
                        handleProssed={onProssedHandler}
                        cutOffPast={cutOffPast}
                    />
                </div>
            </div>
        </div>
    )
}

export default FileItem;
